export const roundUpward = (val: number, decimals?: number): number => {
    const pow = Math.pow(10, decimals ?? 2);
    const roundedNumber = Math.round(val * pow) / pow;
    return val > roundedNumber ? Math.round((roundedNumber + 1 / pow) * pow) / pow : roundedNumber;
};

export const random = (upperLimit: number): number => Math.floor(Math.random() * upperLimit);

export const toCent = (value: number): number => Math.round(value * 100);
